import { Flex } from 'antd'
import { useContext } from 'react'
import { SectionLayoutContext } from '../../../common/SectionCard'
import JobInvoicingBody from '../../InvoiceByJob/JobInvoicingBody'
import ReadyToInvoiceContext from '../ReadyToInvoiceContext'
import DrawerHeader from './DrawerHeader'

const JobEditor = () => {
  const { currentSelection, googleApiKey, setHasPendingEdits } = useContext(ReadyToInvoiceContext)
  if (!currentSelection) {
    return null
  }
  return <JobInvoicingBody spreadVisitToolbar jobId={currentSelection.jobId} googleApiKey={googleApiKey} onPendingEditsChange={setHasPendingEdits}>
    {({ jobData, onLinkCustomer, invoicing, visits }) => <>
      <DrawerHeader jobData={jobData} onLinkCustomer={onLinkCustomer} />
      <div style={{ height: 'calc(100vh - 116px)', overflowY: 'auto', padding: 24 }}>
        <SectionLayoutContext.Provider value="card">
          <Flex vertical gap="large">{invoicing}{visits}</Flex>
        </SectionLayoutContext.Provider>
      </div>
    </>}
  </JobInvoicingBody>
}

export default JobEditor
